export const EnumWorkPortalStatus = {
    unknown: 0,
    unPublished: 1,
    published: 2,
}